import type { BenLanguageCode } from '@ben/common/languages';
import type { ReactNode } from 'react';
import type { HelpMenuProps } from '../help-menu/help-menu';
import HelpMenu from '../help-menu/help-menu';
import LanguageMenu from '../language-menu';

interface IconMenusProps {
  notificationMenu?: ReactNode;
  language?: BenLanguageCode;
  onChangeLanguage?: (value: BenLanguageCode) => void;
  helpMenuProps: HelpMenuProps;
}

const IconMenus = ({
  notificationMenu,
  language,
  onChangeLanguage,
  helpMenuProps,
}: IconMenusProps) => {
  return (
    <>
      <LanguageMenu
        data-testid="language-menu"
        value={language}
        onChange={onChangeLanguage}
      />
      {notificationMenu}
      <HelpMenu {...helpMenuProps} />
    </>
  );
};

export default IconMenus;
